import axios from 'axios';
import _ from 'lodash';
import { batchQuery, getTrucksQuery, getHaulingCompaniesQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { renameKey } from '../../utils';
import Split from '../split';

const getTruckListDetails = ({ includeDeleted, haulingId }) =>
    new Promise((resolve, reject) => {
        const useExpressMigration = Split.getBooleanTreatment('use_express_migration_endpoints');
        const migrationQueryBuilder = useExpressMigration ? buildExpressQuery : buildLoopbackQuery;
        const query = getTrucksQuery({ ...(!includeDeleted && { filterDeleted: true }), haulingId, queryBuilder: migrationQueryBuilder });
        const request = axios.get(query);

        request
            .then((response) => {
                const trucks = response.data;
                if (useExpressMigration) {
                    renameKey(trucks, '_id', 'id');
                }
                const haulingIds = _.filter(_.uniq(_.map(trucks, 'hauling_company')), (id) => !_.isNull(id));

                const haulingCompanyQuery = batchQuery(
                    getHaulingCompaniesQuery,
                    {
                        fields: ['id', 'name'],
                        ids: haulingIds,
                        filterDeleted: true,
                        queryBuilder: migrationQueryBuilder,
                    },
                    'ids'
                );
                const haulingCompanyRequest = _.map(haulingCompanyQuery, (q) => axios.get(q));

                axios.all(haulingCompanyRequest).then(
                    axios.spread((...haulingCompanyResponse) => {
                        const haulingCompanies = _.reduce(haulingCompanyResponse, (acc, val) => [...acc, ...val.data], []);
                        if (useExpressMigration) {
                            renameKey(haulingCompanies, '_id', 'id');
                        }
                        const truckResponse = _.map(trucks, (truck) => {
                            const truckHauler = truck.hauling_company ? truck.hauling_company : '';
                            const hauler = _.find(haulingCompanies, { id: truckHauler });
                            const haulingCompany = truckHauler && hauler && hauler.name ? hauler.name : '';
                            return { ...truck, hauling_company_name: haulingCompany };
                        });
                        resolve({ trucks: truckResponse });
                    })
                );
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getTruckListDetails;
